import routes from './routes'
import store from './store'

export default {
    name: 'm-inbox',
    store: store,
    routes: routes
}